(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-tile-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCarousels = () => {
      document.querySelectorAll('[data-image-tile-showcase]').forEach((section) => {
        if (section.dataset.imageTileCarouselReady === 'true') return;

        const track = section.querySelector('[data-image-tile-track]');
        const previous = section.querySelector('[data-image-tile-previous]');
        const next = section.querySelector('[data-image-tile-next]');

        if (!track || !previous || !next) return;

        section.dataset.imageTileCarouselReady = 'true';

        const updateControls = () => {
          const maxScroll = track.scrollWidth - track.clientWidth;
          previous.disabled = track.scrollLeft <= 1;
          next.disabled = track.scrollLeft >= maxScroll - 1;
        };

        const scrollByCard = (direction) => {
          const card = track.querySelector('.image-tile-showcase__tile');
          const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
          const amount = (card?.getBoundingClientRect().width || track.clientWidth * 0.8) + gap;

          track.scrollBy({ left: direction * amount, behavior: 'smooth' });
        };

        previous.addEventListener('click', () => scrollByCard(-1));
        next.addEventListener('click', () => scrollByCard(1));
        track.addEventListener('scroll', updateControls, { passive: true });
        window.addEventListener('resize', updateControls, { passive: true });
        updateControls();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeCarousels, { once: true });
    } else {
      initializeCarousels();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["material-partners"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll("[data-material-partner-logo]").forEach((card) => {
    card.addEventListener("pointermove", (event) => {
      const rect = card.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;
      card.style.setProperty("--partner-cursor-x", `${x}%`);
      card.style.setProperty("--partner-cursor-y", `${y}%`);
    });

    card.addEventListener("pointerleave", () => {
      card.style.removeProperty("--partner-cursor-x");
      card.style.removeProperty("--partner-cursor-y");
    });
  });

  } catch(e) { console.error(e); }
})();
})();
